export const PricinigPlanSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
  >
    <path
      d="M29.4999 27.1709L24.9139 22.5859L22.0859 25.4139L29.4999 32.8289L42.9139 19.4139L40.0859 16.5859L29.4999 27.1709Z"
      fill="#00086D"
    />
    <path
      d="M54.5 24C54.5 11.852 44.651 2 32.5 2C20.353 2 10.5 11.852 10.5 24C10.5 32.421 15.236 39.735 22.188 43.433L20.5 62L32.5 54L44.5 62L42.812 43.434C49.765 39.736 54.5 32.421 54.5 24ZM32.5 44C21.454 44 12.5 35.046 12.5 24C12.5 12.954 21.454 4 32.5 4C43.546 4 52.5 12.954 52.5 24C52.5 35.046 43.546 44 32.5 44Z"
      fill="#00086D"
    />
  </svg>
);
export const InfoSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
  >
    <g clip-path="url(#clip0_3823_28096)">
      <path
        d="M25.7167 40.1594L24.8679 41.1179C23.1634 42.8223 20.9918 43.9831 18.6277 44.4533C16.2635 44.9236 13.813 44.6822 11.586 43.7598C9.35907 42.8373 7.45564 41.2752 6.11646 39.271C4.77728 37.2668 4.0625 34.9105 4.0625 32.5C4.0625 30.0895 4.77728 27.7332 6.11646 25.729C7.45564 23.7248 9.35907 22.1627 11.586 21.2402C13.813 20.3178 16.2635 20.0764 18.6277 20.5467C20.9918 21.0169 23.1634 22.1777 24.8679 23.8821L40.1321 41.1179C41.8366 42.8223 44.0082 43.9831 46.3723 44.4533C48.7365 44.9236 51.187 44.6822 53.414 43.7598C55.6409 42.8373 57.5444 41.2752 58.8835 39.271C60.2227 37.2668 60.9375 34.9105 60.9375 32.5C60.9375 30.0895 60.2227 27.7332 58.8835 25.729C57.5444 23.7248 55.6409 22.1627 53.414 21.2402C51.187 20.3178 48.7365 20.0764 46.3723 20.5467C44.0082 21.0169 41.8366 22.1777 40.1321 23.8821L39.2833 24.8406"
        stroke="#479821"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3823_28096">
        <rect width="65" height="65" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const CorrectSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clip-path="url(#clip0_3823_28103)">
      <path
        d="M6.89142 11.9861C6.8133 12.0641 6.68672 12.0641 6.60864 11.986L3.76342 9.1408C3.68551 9.0629 3.55926 9.06267 3.48108 9.14031L2.69992 9.91596C2.62134 9.99399 2.62112 10.121 2.69942 10.1993L6.60857 14.1085C6.68668 14.1866 6.81331 14.1866 6.89142 14.1085L15.6086 5.3913C15.6867 5.3132 15.6867 5.18657 15.6086 5.10846L14.8338 4.33374C14.7558 4.25566 14.6292 4.25563 14.5511 4.33367L6.89142 11.9861Z"
        fill="#00086D"
      />
    </g>
    <defs>
      <clipPath id="clip0_3823_28103">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
